'use strict';
import Base  from './FooterBase';
import Render  from './FooterRender';
import { connect } from 'react-redux';

class Footer extends Base {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

// export default Footer
export default Footer = connect((state)=>{
    return {user:state.user || {}}
})(Footer);